import React, { useState } from 'react'
import Form from 'react-bootstrap/Form'
import defaultJson from '../../../../helpers/example-data/defaultInstagramIntent.json'

interface IProps {
  intent: any
  inputJson: any[]
  setInputJson: React.Dispatch<React.SetStateAction<any[]>>
  closeModal: () => void
  newIntentId: any
  setNewIntentId: any
}

const AddInstaIntent: React.FC<IProps> = ({
  inputJson,
  setInputJson,
  intent,
  closeModal,
  newIntentId,
  setNewIntentId
}) => {
  const [isValidIntentId, setIsValidIntentId] = useState(true)
  const [newIntentType, setNewIntentType] = useState('')
  const [isFormValid, setIsFormValid] = useState(false)
  const [isIntentIdPresent, setIsIntentIdPresent] = useState(true)
  const intentIndex = inputJson.findIndex((item) => item.id === intent.id)

  const handleIntentIdChange = (e: any) => {
    const numericValue = e.target.value.replace(/\D/g, '')
    const isNumericValueValid = inputJson.some((obj) => obj.id === parseInt(numericValue, 10))
    const isValid = numericValue.length > 0

    setIsValidIntentId(isValid)
    setIsIntentIdPresent(!isNumericValueValid)
    setNewIntentId(numericValue)
    updateFormValidity(isValid && !!newIntentType)
  }

  const handleTypeChange = (e: any) => {
    const selectedValue = e.target.value
    setNewIntentType(selectedValue)
    updateFormValidity(!!newIntentId && !!selectedValue)
  }

  const updateFormValidity = (isValid: boolean) => {
    setIsFormValid(isValid)
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()

    const selectedItem = defaultJson.find((item: any) => item.type === newIntentType)
    const newObjToAdd = { ...selectedItem?.intent, id: parseInt(newIntentId) }

    setInputJson((prevValue) => [
      ...prevValue.slice(0, intentIndex + 1),
      newObjToAdd,
      ...prevValue.slice(intentIndex + 1)
    ])
    closeModal()
  }

  const getInetntType = (intentType: any) => {
    switch (intentType) {
      case 'text':
        return 'Text'
      case 'photoOrGIF':
        return 'Photo or GIF'
      case 'audio':
        return 'Audio'
      case 'video':
        return 'Video'
      default:
        return 'Text'
    }
  }
  return (
    <form onSubmit={handleSubmit}>
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark d-flex'>Intent Id</label>
        <input
          className={`form-control form-control-lg form-control-solid ${
            !isValidIntentId || !isIntentIdPresent ? 'is-invalid' : ''
          }`}
          type='text'
          autoComplete='off'
          data-toggle='tooltip'
          data-placement='top'
          title='Intent Id have to be unique'
          value={newIntentId}
          onChange={handleIntentIdChange}
        />
        {!isValidIntentId && (
          <div className='invalid-feedback'>Please enter a valid Intent ID.</div>
        )}
        {!isIntentIdPresent && <div className='invalid-feedback'>Inetnt ID being used.</div>}
      </div>
      <div className='fv-row mb-10'>
        <label className='form-label fs-6 fw-bolder text-dark d-flex'>Intent type</label>
        <Form.Select
          aria-label='Select htmlInputTypes'
          className='form-control form-control-lg form-control-solid'
          value={newIntentType}
          onChange={handleTypeChange}
        >
          {defaultJson.map((item: any, index: number) => (
            <>
              <option value='' disabled selected hidden>
                Select a Intent Type
              </option>
              <option key={index} value={item.type}>
                {getInetntType(item.type)}
              </option>
            </>
          ))}
        </Form.Select>
      </div>
      <div className='d-flex justify-content-end'>
        <button
          type='submit'
          className='btn btn-sm btn-primary'
          disabled={!isFormValid || !isIntentIdPresent}
        >
          <span className='indicator-label'>Add Intent</span>
        </button>
      </div>
    </form>
  )
}

export default AddInstaIntent
